import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { GlobalService } from './_services/global.service';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    title = 'app';
    // _globalService: GlobalService;

    constructor(
        public globalService: GlobalService,
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document
    ) {
        console.debug('AppComponent.construcator()');
        // this._globalService = globalService;
        this.renderer.addClass(this.document.body, 'wtw-calc-htmlbody');
    }

    // constructor(private globalService: GlobalService) {
    //     console.debug('AppComponent().construcator()');
    // }
}
